const { LIST_NAMES } = require('../../analyticsConst');
const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const { createEcommerceEventItemsGA4 } = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const positionUtils = require('../utils/positionUtils');

/* -------------------------------------------------------------------------- *\
 * PRODUCT SLIDER EVENTS                                                      *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Slider Loaded
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.productSliderLoaded, (payload) => {
    const productsData = payload.products.map((product, index) => ({
      ...product.product,
      itemProps: {
        index: positionUtils.oneBasedPosition(index),
        item_list_id: LIST_NAMES.contextList[payload.context] ?? payload.context,
        product_id_with_size: undefined,
        searched_term: payload.searched_term || undefined,
      },
    }));
    pushEvent(
      createEcommerceEventGA4('view_item_list', createEcommerceEventItemsGA4(productsData)),
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
